import axios from 'axios';

const API = process.env.VUE_APP_API_URL || 'http://127.0.0.1:5000';

export const getRoutines = async (userId) => {
  // backend expects query param user_id
  const res = await axios.get(`${API}/api/routines/`, { params: { user_id: userId } });
  return res.data;
};

export const getRoutine = async (userId, routineId) => {
  const res = await axios.get(`${API}/api/routine//`, { params: { user_id: userId, routine_id: routineId } });
  return res.data;
};

export const updateRoutine = async (userId, routineId, payload) => {
  const res = await axios.post(`${API}/api/routine//`, payload, { params: { user_id: userId, routine_id: routineId } });
  return res.data;
};

export const resetRoutineSession = async (userId, sessionId) => {
  const res = await axios.delete(`${API}/api/routines/`, { params: { user_id: userId, session_id: sessionId } });
  return res.data;
};

export default { getRoutines, getRoutine, updateRoutine, resetRoutineSession };


